var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseLeftClick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0075ff;}.cls-2,.cls-3{fill:#fff;}.cls-2{fill-opacity:0.3;}.cls-4{fill:#eb5757;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mouse-left-click"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.31,10.28a5.11,5.11,0,0,0-1.24-1.72A5.67,5.67,0,0,0,19.21,7.4,6.25,6.25,0,0,0,17,7H14.73a5.94,5.94,0,0,0-4.05,1.56A5.08,5.08,0,0,0,9,12.31v6.38a5.08,5.08,0,0,0,1.68,3.75A5.94,5.94,0,0,0,14.73,24H17a6.25,6.25,0,0,0,2.19-.4,5.67,5.67,0,0,0,1.86-1.16,5.11,5.11,0,0,0,1.24-1.72,4.91,4.91,0,0,0,.44-2V12.31A4.91,4.91,0,0,0,22.31,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.38,10.89a4.85,4.85,0,0,0-1.06-1.52A5.07,5.07,0,0,0,16.85,8h-2a5,5,0,0,0-3.47,1.37A4.62,4.62,0,0,0,10,12.69v5.62a4.62,4.62,0,0,0,1.43,3.32A5,5,0,0,0,14.9,23h2a5.07,5.07,0,0,0,3.47-1.37,4.85,4.85,0,0,0,1.06-1.52,4.64,4.64,0,0,0,.37-1.8V12.69A4.64,4.64,0,0,0,21.38,10.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.69,9h-.41v4.88h4.47v-.82a4.12,4.12,0,0,0-.31-1.55,4,4,0,0,0-2.2-2.2A4.12,4.12,0,0,0,16.69,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.47,9h-.41A4.06,4.06,0,0,0,11,13.06v.82h4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,17.94A4.06,4.06,0,0,0,15.06,22h1.63a4.12,4.12,0,0,0,1.55-.31,4,4,0,0,0,2.2-2.2,4.12,4.12,0,0,0,.31-1.55V14.69H11Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseLeftClick);
export default __webpack_public_path__ + "static/media/mouse-left-click.9b485cae80551460d2e6bb8b8f31328c.svg";
export { ForwardRef as ReactComponent };